// extracted by mini-css-extract-plugin
module.exports = {"card":"benefitCard_card__f2jDG","imgContainer":"benefitCard_imgContainer__rDjDW","cardContent":"benefitCard_cardContent__P_DwB","knowMore":"benefitCard_knowMore__rnxre"};